import React, { useState } from 'react';
import { Modal } from 'quanta-ui';

import MainFragment from './main-fragment';
import EmailFragment from './email-fragment';
import SMSFragment from './sms-fragment';

export default function DownloadAndShare({
  showDownloadAndShare,
  setShowDownloadAndShare,
  renewalInput,
}) {
  const [pageState, setPageState] = useState({
    main: true,
    email: false,
    sms: true,
  });

  return (
    <Modal
      display={showDownloadAndShare}
      onClose={() => setShowDownloadAndShare(false)}
      title="Download & Share"
    >
      {pageState.main ? (
        <MainFragment
          renewalInput={renewalInput}
          doClose={() => {
            setShowDownloadAndShare(false);
            document.body.classList.remove('overflow-y-hidden');
          }}
          showEmail={() =>
            setPageState({
              main: false,
              email: true,
              sms: false,
            })
          }
          showSMS={() =>
            setPageState({
              main: false,
              email: false,
              sms: true,
            })
          }
        />
      ) : pageState.email ? (
        <EmailFragment
          renewalInput={renewalInput}
          goBack={() =>
            setPageState({
              main: true,
              email: false,
              sms: false,
            })
          }
        />
      ) : pageState.sms ? (
        <SMSFragment
          renewalInput={renewalInput}
          goBack={() =>
            setPageState({
              main: true,
              email: false,
              sms: false,
            })
          }
        />
      ) : (
        <></>
      )}
    </Modal>
  );
}
